import React from 'react'
import Card from '../../commons/Card'
import { connect } from 'react-redux';
import GreyBig from './GreyBig'
import ResidentialHistory from './ResidentialHistory'
import { getLoanApplicationPurpose } from '../../../reducers'

class PersonalDetail extends React.Component {
  renderResidentialHistories = (profile) => {
    return profile.residentialHistories.map((history, index) => (
      <ResidentialHistory key={index} histories={profile.residentialHistories} history={history} />
    ))
  }

  renderDocuments = (profile) => {
    const doc = profile.profileDocument
    return (
      <div>
        { doc.driverLicenseNumber &&
            <div>
              <div className='d-block'>Driver license</div>
              <div className='d-block'>Document No: {doc.driverLicenseNumber}</div>
              <div className='d-block'>State of issue: {doc.stateOfIssue}</div>
              <hr/>
            </div>
        }
        { doc.australiaPassportNumber &&
            <div>
              <div className='d-block'>Australian passport</div>
              <div className='d-block'>Document No: {doc.australiaPassportNumber}</div>
              <hr/>
            </div>
        }
        { doc.internationalPassportNumber &&
            <div>
              <div className='d-block'>International passport</div>
              <div className='d-block'>Document No: {doc.internationalPassportNumber}</div>
              <div className='d-block'>Country of issue: {doc.countryOfIssue}</div>
              <hr/>
            </div>
        }
        { doc.medicareCardNumber &&
            <div>
              <div className='d-block'>Medicare</div>
              <div className='d-block'>Document No: {doc.medicareCardNumber}</div>
              <div className='d-block'>Reference No: {doc.medicareReferenceNumber}</div>
              <div className='d-block'>Middlename on card: {doc.medicareMiddlenameOnCard}</div>
              <div className='d-block'>Card colour: {doc.medicareCardColour}</div>
              <div className='d-block'>Valid to: {doc.medicareValidTo}</div>
            </div>
        }
      </div>
    )
  }

  render() {
    const { profile } = this.props

    const reviewProfile = (profile) => {
      return (
        <div className='card card-single'>
          <div className='card-header'>
            <div className='pull-right'>
              <a className='smaller' href='#' onClick={ () => this.props.onGoToClick('personal_details')}>Edit</a>
            </div>
            Personal details - {profile.name}
          </div>
          <div className='card-body'>
            <GreyBig size='4' grey='Name' big={profile.name}/>
            <GreyBig size='4' grey='Date of birth' big={profile.dateOfBirth}/>
            <GreyBig size='4' grey='Email address' big={profile.email}/>
            <GreyBig size='4' grey='Phone number' big={profile.mobile}/>
            <div className='mb-4'>
              <div className='grey'>
                Residential history
              </div>
              <div className='pt-1'></div>
              {this.renderResidentialHistories(profile)}
            </div>
            { (gon.loan_application.enable_verification && this.props.purpose == 'refinance') &&
              <div className='mb-3'>
                <div className='grey'>
                  Identity
                </div>
                <div className='big'>
                  {this.renderDocuments(profile)}
                </div>
              </div>
            }
          </div>
        </div>
      )
    }

    return profile.map(profile => {
      return reviewProfile(profile)
    })

  }
}

const mapStateToProps = (state, ownProps) => ({
  profile: state.review.profile,
  purpose: getLoanApplicationPurpose(state)
})

export default connect(mapStateToProps, {
})(PersonalDetail)
